export const AuthErrorView = () =>
  "Access failed. Access through Reviso app is required.";

// TODO: implement GUI
